import styled from '@emotion/styled/macro';
import { useEffect, useState } from 'react';
import { BlockHeading } from '../../components/Text/Heading';
import PreventionItem from './PreventionItem';
import { ReactComponent as IconPrevention } from '../../svgs/icon-shield.svg';

const Box = styled.div`
  --box-padding: 1.2rem;
  --box-border-radius: 10px;
  background-color: var(--color-dark-shade);
  border-left: 3px solid var(--color-actuators);
  border-radius: var(--box-border-radius);
  z-index: 10;
  align-self: center;
  width: 90%;
  max-width: 22rem;
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  top: calc(100px + 50px);
`;

const Triangle = styled.div`
  position: absolute;
  top: -8px;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 0;
  border-bottom: 8px solid var(--tint-critical);
`;

const Head = styled.div`
  background-color: var(--tint-critical);
  /* The 3px accent on the box already supplies part of the left inset, so take it
     back off the padding: the text stays put and the title keeps the width. */
  padding: 0.66em var(--box-padding) 0.66em calc(var(--box-padding) - 3px);
  border-top-right-radius: var(--box-border-radius);
  border-top-left-radius: calc(var(--box-border-radius) - 3px);
  grid-area: text;
  font-size: var(--font-size-16);
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  gap: var(--spacing-10);
  align-items: center;
  & > svg {
    flex-shrink: 0;
  }
`;


const List = styled.ul`
  padding: calc(var(--box-padding) / 2);
  list-style: none;
  display: grid;
  grid-gap: 0.1rem;
  margin: 0;
  font-size: var(--font-size-14);
  max-height: 240px;
  overflow-y: auto;
  width: 100%;
`;

const ListItem = styled.li`
  padding: calc(var(--box-padding) / 2);
  border-radius: var(--box-border-radius);
  width: 100%;
  &:hover {
    background-color: var(--color-dark);
  }
`;

export const PreventionBox = (props) => {
  const { preventions, compact } = props;
  const [expandedIndex, setExpandedIndex] = useState(0);
  const preventionIds = preventions.map((prevention) => prevention.actid).join();

  useEffect(() => {
    setExpandedIndex(0);
  }, [preventionIds]);

  return (
    <Box key="box">
      <Triangle />
      <Head>
        <Row>
          {!compact && (
            <IconPrevention
              stroke="var(--color-actuators)"
              strokeWidth="1"
              fill="none"
              width="1rem"
              height="1.2rem"
            />
          )}
          <BlockHeading>Critical Action</BlockHeading>
        </Row>
      </Head>
      <List>
        {preventions.map((prevention, index) => (
          <ListItem key={prevention.actid}>
            <PreventionItem
              prevention={prevention}
              isExpanded={index === expandedIndex}
              onToggle={() => setExpandedIndex(index === expandedIndex ? null : index)}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
